import { useState } from 'react';
import { getVideo } from '../helpers';

export const useVideoState = ({
    video_source_type,
	video_solution,
	video_solution_platform_media,
	video_solution_iframe
}) => {
  const [video, setVideo] = useState(
    getVideo({
        video_source_type,
        video_solution,
        video_solution_platform_media,
        video_solution_iframe
    })
  );
  
  const [videoType, setVideoType] = useState(
    video_source_type ?? ''
  );

  const toggleVideo = (
    {
        video_source_type,
        video_solution,
        video_solution_platform_media,
        video_solution_iframe
    }
  ) => {
    setVideo(
        getVideo({
            video_source_type,
            video_solution,
            video_solution_platform_media,
            video_solution_iframe
        })
    )
  }

  return { video, toggleVideo, videoType, setVideoType };
}